import React, { useEffect, useState } from "react";
import "../Admin/admin.css";

const API = "https://suivi.amservices.eu/api";

export default function ArchivesRma() {
    const [archives, setArchives] = useState([]);
    const [loading, setLoading] = useState(true);

    const loadArchives = async () => {
        setLoading(true);
        try {
            const r = await fetch(`${API}/get_archives_rma.php`, { credentials: "include" });
            const d = await r.json();
            if (d.success) setArchives(d.data);
        } catch (e) { console.error(e); }
        setLoading(false);
    };

    useEffect(() => { loadArchives() }, []);

    const restore = async (id) => {
        // Remet l'état à 'recu' par défaut lors de la restauration
        await fetch(`${API}/update_etat_rma.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id, etat: 'recu' })
        });
        loadArchives();
        alert("Dossier RMA restauré ✔");
    };

    const remove = async (id) => {
        if (!window.confirm("Supprimer définitivement ce dossier RMA de la base ?")) return;
        await fetch(`${API}/delete_rma_permanent.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include",
            body: JSON.stringify({ id })
        });
        loadArchives();
    };

    return (
        <div className="admin-page">
            <div className="page-content">
                <h1>📦 Archives Gestion RMA</h1>

                {loading && <p style={{ textAlign: 'center' }}>Chargement...</p>}

                <table className="repair-table">
                    <thead>
                        <tr>
                            <th>Client</th>
                            <th>Matériel</th>
                            <th>Constructeur</th>
                            <th>Réf Dossier</th>
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {archives.length === 0 && !loading && (
                            <tr><td colSpan="5" style={{ textAlign: 'center' }}>Aucune archive RMA</td></tr>
                        )}
                        {archives.map(a =>
                            <tr key={a.id}>
                                <td>
                                    <strong>{a.client_nom}</strong><br />
                                    <small>{a.client_tel}</small>
                                </td>
                                <td>{a.materiel}</td>
                                <td>{a.constructeur}</td>
                                <td><code>{a.ref_constructeur || "N/A"}</code></td>
                                <td className="actions-menu">
                                    <button title="Restaurer" className="btn-recup" onClick={() => restore(a.id)}>↩</button>
                                    <button title="Supprimer définitivement" className="btn-archive" onClick={() => remove(a.id)}>🗑</button>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}